import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=3bcdfea4&scoped=true&"
import script from "./organizations.vue?vue&type=script&lang=js&"
export * from "./organizations.vue?vue&type=script&lang=js&"
import style0 from "./organizations.vue?vue&type=style&index=0&id=3bcdfea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdfea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcdfea4')) {
      api.createRecord('3bcdfea4', component.options)
    } else {
      api.reload('3bcdfea4', component.options)
    }
    module.hot.accept("./organizations.vue?vue&type=template&id=3bcdfea4&scoped=true&", function () {
      api.rerender('3bcdfea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/organizations.vue"
export default component.exports